module.exports = __webpack_public_path__ + "media/img/use-ico-2-aae13706a82a612d7e819c633acf7664.svg";